import { Type } from '@angular/core';
import { ISizeName } from '@df/core/service/client';
import { Status } from '@df/core/status';
import { AbstractDfModalInitiatorService } from '@df/ui/modal/abstract-df-modal-initiator.service';
import { ModalConfig, TModalPosition } from '@df/ui/modal/modal-config';

export namespace NDfModal {
    /**
     * Event name to open a preregistered cms modal window
     */
    export const EventModalOpen = 'cmsModalOpen';

    export interface IBaseModalConfig<D = any> {
        /**
         * Component modal id must much CMS BLock URL
         */
        id: string;
        name?: string;
        description?: string;
        component: Type<IModalComponent>;
        type: 'cmsmodal' | 'modal';
        config?: ModalConfig | ((sizeId: ISizeName, data?: D) => ModalConfig);
        position?: TModalPosition | ((sizeId: ISizeName, data?: D) => TModalPosition | undefined);
        initiators?: Type<AbstractDfModalInitiatorService>[];
        blockGroup?: string;
        priority?: number;
        prerenderAllowed?: boolean;
        reopenPolicy: ReopenPolicy;
        sizeRestriction: TSizeRestriction;
        allowedLocation?: RegExp;
        forbiddenLocation?: RegExp;
        // allows modal to show up automatically in iCMS using initiator service
        allowInCms?: boolean;
        /**
         * Block will be created if cant be loaded
         */
        autoCreate?: boolean;
    }

    export type TSizeRestriction = ISizeName[] | ((sizeId: ISizeName) => ISizeName[] | string[]);
    /**
     * How to proceed if same modal is already open
     *
     * wait - display after currently open is closed
     * both - display both
     * first - keep first one open, ignore second
     * last - close first and open new one
     * passData - pass data again to open modal
     */
    export enum ReopenPolicy {
        wait,
        both,
        first,
        last,
        passData
    }

    /**
     * Modal window configuration
     */
    export interface IModalConfig<D = any> extends IBaseModalConfig<D> {
        variant?: string;
        // pass true if you want to load modal data in background
        prefetch?: boolean;
        component: Type<IModalComponent>;
    }

    export type IConfig<D = any> = IBaseModalConfig<D> | IModalConfig<D>;

    export interface IModalComponent {
        modalConfig?: IModalConfig;
        updateModalData?: (data: any) => void;
    }

    /**
     * CMS modal open even data
     */
    export interface IOpenRequest {
        status?: Status;
        id: string;
        variant?: string;
    }

    export interface IOpenOptions {
        createOnError?: boolean;
    }
}
